/**
 * 下载 Blob 文件
 */
export function downloadBlob (blob, fileName) {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  setTimeout(() => {
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }, 100)
}

const EXCEL_CONTENT_TYPES = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
]

function isExcelContentType (type) {
  return EXCEL_CONTENT_TYPES.some(item => type && type.includes(item))
}

/**
 * 处理导入接口返回的 blob 响应（支持 JSON 成功/失败 或 Excel 错误文件下载）
 * @param {Blob|Object} response axios 响应（responseType 为 blob 时为 Blob）
 * @param {Object} options
 * @param {string} options.errorFileName 错误 Excel 默认文件名
 * @returns {Promise<{success: boolean, hasErrorFile: boolean, message: string}>}
 */
export function handleImportBlobResponse (response, options = {}) {
  const { errorFileName = '导入失败数据.xlsx' } = options

  if (!(response instanceof Blob)) {
    if (response && response.code === 0) {
      return Promise.resolve({
        success: true,
        hasErrorFile: false,
        message: response.message || '导入成功'
      })
    }
    return Promise.reject(new Error((response && response.message) || '导入失败'))
  }

  const blob = response

  if (blob.size === 0) {
    return Promise.resolve({
      success: true,
      hasErrorFile: false,
      message: '导入成功'
    })
  }

  if (isExcelContentType(blob.type)) {
    downloadBlob(blob, errorFileName)
    return Promise.resolve({
      success: true,
      hasErrorFile: true,
      message: '部分数据导入失败，请查看下载的文件'
    })
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const content = reader.result || ''

      if (content.startsWith('PK')) {
        downloadBlob(blob, errorFileName)
        resolve({
          success: true,
          hasErrorFile: true,
          message: '部分数据导入失败，请查看下载的文件'
        })
        return
      }

      try {
        const result = JSON.parse(content)
        if (result.code === 0) {
          resolve({
            success: true,
            hasErrorFile: false,
            message: result.message || '导入成功'
          })
        } else {
          reject(new Error(result.message || '导入失败'))
        }
      } catch (e) {
        resolve({
          success: true,
          hasErrorFile: false,
          message: '导入成功'
        })
      }
    }
    reader.onerror = () => reject(new Error('读取导入结果失败'))
    reader.readAsText(blob)
  })
}
